// extracted by mini-css-extract-plugin
export default {"back":"AuditionDetailBack_back__niDhK","arrow":"AuditionDetailBack_arrow__vHOUA"};